import { useEffect, useState } from "react";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { Modal } from "../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { _AcademicEducation } from "../../../../../core/services/dataBean/EntityCatalogVdos";
import { _single } from "../../../../../core/services/dataBean/EntityCatalog";
import { SelectTHConstantsValue } from "../../../../bpm/config/Componentes/SelectTHConstantsValue";
import { InputDate } from "../../../../theme/Input/InputDate";
import { BasicSwitch } from "../../../../theme/Component/BasicSwitch";
import { DepartamentCitiesEditor } from "../../../../../portal/componets/pages/IndexPage/Components/PersonarDataUser/Components/DepartamentCitiesEditor";
import { SelectSiteID } from "../../../../admin/configuracion/SiteID/SelectSiteID";
import { CountryEditor } from "../../../../../portal/componets/pages/IndexPage/Components/PersonarDataUser/Components/CountryEditor";
import usePaginator from "../../../../theme/Component/usePaginator";


interface Props {
    Account: number;
}

export const AcademicEducationAccount = ({ Account }: Props) => {

    const AcademicEducationAccount = useDataBean(_AcademicEducation);
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const paginador = usePaginator();
    useEffect(() => {
        getListavdos();
    }, [Account])

    const getLista = () => {

        AcademicEducationAccount.instance.getAcademicEducationAccountCatalogPorPropiedades({ State: 1, IDAccount: Account }, null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                    console.log(resp)
                }
            }
        )

    }

    const getListavdos = () => {

        AcademicEducationAccount.instance.getAcademicEducationAccountReport(paginador.page, 15, { State: 1, IDAccount: Account }).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * 15);
                    paginador.setRegiPerPage(15);
                    setLista(resp.List)
                }
            }
        )

    }

    const create = () => {
        AcademicEducationAccount.setBean({
            IDAccount: Account,
            State: 1,
            IDEmployee: _single.getAccountID(),
        });
        setModal({ ...modal, "view": true });
    }

    const editaItem = () => {
        ////console.log(SubMacroProcess.bean);
        AcademicEducationAccount.update().then(
            (resp: any) => {
                getListavdos();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const deleteItem = () => {
        AcademicEducationAccount.bean.State = 2;
        //console.log(Project.bean);
        editaItem();
        setModalC({ ...modalC, "view": false });

    }
    const head = [
        { title: 'ID', property: 'IDAcademicEducationAccount', visible: true },
        { title: 'Nivel Educativo', property: 'IDEducationLevelName', visible: true },
        { title: 'Titulo', property: 'DegreeTitle', visible: true },
        { title: 'Institucion Educativa', property: 'IDInstitutionName', visible: true },
        { title: 'Fecha Inicial', property: 'StartDate', visible: true },
        { title: 'Fecha Final', property: 'EndDate', visible: true },
        { title: 'Completado', property: 'IsCompleted', visible: true },
        { title: 'Pais estudio', property: 'NameCountry', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [

            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={AcademicEducationAccount.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador}></BasicTable>
                <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                    <div className="row">
                        <div className="col-md-12">
                            <label>Nivel Educativo</label>
                            <SelectTHConstantsValue code={803} value={AcademicEducationAccount.bean.IDEducationLevel} onChange={(e: any) => { AcademicEducationAccount.setBean({ ...AcademicEducationAccount.bean, "IDEducationLevel": e }) }}></SelectTHConstantsValue>
                        </div>
                        <div className="col-md-6">
                            <label>Titulo</label>
                            <input type='text' name="DegreeTitle" className="form-control" value={AcademicEducationAccount.bean.DegreeTitle} onChange={AcademicEducationAccount.handleChange} />
                        </div>
                        <div className="col-md-6">
                            <label>Institucion Educativa</label>
                            <SelectTHConstantsValue code={103} value={AcademicEducationAccount.bean.IDInstitution} onChange={(e: any) => { AcademicEducationAccount.setBean({ ...AcademicEducationAccount.bean, "IDInstitution": e }) }}></SelectTHConstantsValue>
                        </div>
                        <div className="col-md-6">
                            <InputDate name="StartDate" label="Fecha Inicial" value={AcademicEducationAccount.bean.StartDate} setDate={(e: any) => { AcademicEducationAccount.setBean({ ...AcademicEducationAccount.bean, "StartDate": e }) }} />
                        </div>
                        <div className="col-md-6">
                            <InputDate name="EndDate" label="Fecha Final" value={AcademicEducationAccount.bean.EndDate} setDate={(e: any) => { AcademicEducationAccount.setBean({ ...AcademicEducationAccount.bean, "EndDate": e }) }} />
                        </div>
                        <div className="col-md-6">
                            <label>Pais estudio</label>

                            <CountryEditor idSelector={AcademicEducationAccount.bean.IDCountry} onChange={(e) => { AcademicEducationAccount.setBean({ ...AcademicEducationAccount.bean, "IDCountry": e.IDCountries }) }} label=" " />

                            {/* <DepartamentCitiesEditor
                                idSelector={AcademicEducationAccount.bean.IDCountry}
                                onChange={(e) => AcademicEducationAccount.setBean({ ...AcademicEducationAccount.bean, 'IDCountry': e.IDCities, 'renderValue': e.Ciudad ?? e.Name })}

                            /> */}
                        </div>
                        <div className="col-md-6">
                            <BasicSwitch estado={AcademicEducationAccount.bean.IsCompleted} label="Completado ?" eventChange={(e: any) => {
                                AcademicEducationAccount.setBean({ ...AcademicEducationAccount.bean, "IsCompleted": e })
                            }}></BasicSwitch>
                        </div>

                    </div>
                </Modal>

                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar item</strong>
                </ModalConfirm>
            </div>

        </div>
    )
}